<template>
  <mdb-container class="gp-has-header">
    <div v-if="!loggedIn">
      <mdb-card>
        <mdb-card-header class="secondary-color text-white">
          <p class="h5">Start a New {{ capitalize($tc("common.label.group",1)) }}</p>
        </mdb-card-header>
        <mdb-card-body>
          To get started, please
          <router-link to="/login">Login</router-link>
          or
          <router-link to="/register">register a new account</router-link>
          .
        </mdb-card-body>
      </mdb-card>
    </div>

    <div v-if="showForm && loggedIn" class="create-group-form">
      <mdb-card style="width:100%">
        <mdb-card-header class="secondary-color text-white">
          <p class="h5">Start a New  {{ capitalize($tc("common.label.group",1)) }}</p>
        </mdb-card-header>
        <mdb-card-body>
          <h4 class="text-info"
              v-if="settings.billingEngine == 'GPBillingEngine' || settings.billingEngine=='EzumeeBillingEngine'">
            It's free to start a {{ capitalize($tc("common.label.group",1)) }}.</h4>
          <a v-if="pricingText" href="#" @click.stop.prevent="showPricing=true">Read
            about pricing.</a>
          <form class="text-left needs-validation" v-on:submit.prevent="doCreate">
            <div class="grey-text text-left">
              <mdb-input id="group-name" v-model="group.name" icon="users"
                         :label="capitalize($tc('common.label.group',1)) + ' Name'" required
                         type="text"/>
              <mdb-input id="group-description" v-model="group.summary" :rows="2" icon="comment"
                         label="Brief Description"
                         required
                         type="text"/>
              <div v-if="settings && settings.recaptchaEnabled && settings.recaptchaSiteKey">
                Confirm You're Human<br/>
                <VueRecaptcha :loadRecaptchaScript="true"
                              :sitekey="settings.recaptchaSiteKey"
                              size="compact" theme="light" @expired="expiredRecaptcha"
                              @verify="gotRecaptcha"/>
              </div>

            </div>
            <mdb-btn type="submit">Create</mdb-btn>

          </form>
        </mdb-card-body>
      </mdb-card>
      <mdb-modal v-if="showPricing" @close="showPricing=false" size="lg">
        <mdb-modal-header :close="true" class="primary-color text-white">
          <h3><i class="fa fa-piggy-bank"></i>&nbsp; Pricing Information</h3>
        </mdb-modal-header>
        <mdb-modal-body class="text-left" v-html="pricingText"/>
        <mdb-modal-footer>

          <mdb-btn @click="showPricing=false" size="sm" icon="check">Ok, Got It</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </div>
  </mdb-container>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader
} from 'mdbvue';

import VueRecaptcha from 'vue-recaptcha';
import utils from "../../services/utils";

export default {
  name: 'Create-Group',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbIcon,
    mdbCardHeader,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbContainer,
    VueRecaptcha
  },
  computed: {
    apiKey: function () {
      return this.$store.state.apiKey
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    loggedIn: function () {
      return this.$store.state.loggedIn
    },
    settings: function () {
      return this.$store.state.settings
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    }
  },
  data() {
    return {
      group: {
        name: "",
        summary: "",
        recaptcha: null
      },
      showForm: true,
      pricingText: null,
      showPricing: false
    }
  },
  mounted() {
    document.title = "New " + utils.capitalize(this.$tc("common.label.group",1))
    api.get("/public/pricingText", this.group).then(
      (results) => {
        this.pricingText = results.data
      },
      (error) => {
        console.error("Could not get pricing text.",error.response.data)
      }
    )
  },
  methods: {
    doCreate: function () {
      if (this.settings.recaptchaEnabled && !this.group.recaptcha) {
        this.$notify.error({message: "Please confirm that you are a human.", timeOut: 8000})
        return
      }
      this.$store.dispatch("setExecuting", true)
      this.showForm = false

      api.put("/group/create", this.group).then(
        (results) => {
          api.reloadUser()
          this.$router.push("/group/setup/" + results.data.uri)
        },
        (error) => {
          this.showForm = true
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    gotRecaptcha: function (recap) {
      this.group.recaptcha = recap
    },
    expiredRecaptcha: function () {
      this.group.recaptcha = null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 749px ) {
  .create-group-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .create-group-form {
    margin: auto;
    width: 50%;
  }


}

</style>
